import config from '../config/configureEnv';
import {
  ajax,
  getUserAuthDataFromLocalStorage,
} from '../utils';

export default {
  getMetadata: () => {
    const access_token = getUserAuthDataFromLocalStorage().accessToken;
    return ajax('GET', `${config.bocaAPIUrl}/metadata`, {
      urlParams: { access_token },
    });
  },

  createMetadata: (data) => {
    const access_token = getUserAuthDataFromLocalStorage().accessToken;
    return ajax('POST', `${config.bocaAPIUrl}/metadata`, {
      urlParams: { access_token },
      data: JSON.stringify(data),
    });
  },

  updateMetadata: ({ id, ...newValue }) => {
    const access_token = getUserAuthDataFromLocalStorage().accessToken;
    return ajax('PATCH', `${config.bocaAPIUrl}/metadata/${id}`, {
      urlParams: { access_token },
      data: JSON.stringify(newValue),
    });
  },

  deleteMetadata: (id) => {
    const access_token = getUserAuthDataFromLocalStorage().accessToken;
    return ajax('DELETE', `${config.bocaAPIUrl}/metadata/${id}`, {
      urlParams: { access_token },
    });
  },

  getMetadataType: () => {
    const access_token = getUserAuthDataFromLocalStorage().accessToken;
    return ajax('GET', `${config.bocaAPIUrl}/metadataTypes`, {
      urlParams: { access_token },
    });
  },
};



// WEBPACK FOOTER //
// ./src/api/MetadataAPIConnectors.js